import React, { useRef, useState } from "react";
import { Table } from "react-bootstrap";
import { useSelector } from "react-redux";
import { useEditEventDetails } from "../../../Logic/useEditEventDetails";
import AddStaffCard from "../AddStaffCard";
import AssignedProjectDetails from "../AddStaffCard/AssignedProjectDetails";
import { AddNewFolderModal } from "../ContentHeader/AddNewFolderModal";
import Style from "./ContractStaff.module.scss";
import TableHeader from "./TableHeader";
import { useEffect } from "react";
import { ShimmerThumbnail } from "react-shimmer-effects";
import { useDimensions } from "../../../Logic/Dimensions";
import Assets from "../../Layouts/Assets";

const ContractStaff = React.forwardRef(
  (
    {
      staffViewData,
      handleStaffFilter,
      handletoggleStaffEdit,
      handleSetStaffEditData,
      handletoggleAssignedProjects,
      handlesetAssignedProjects,
      designations,
    },
    ref
  ) => {
    const [isActiveDropdown, setIsActiveDropdown] = useState("All");
    const { assignedProjects, status } = useSelector((state) => state.staffs);
    const windowDimensions = useDimensions();

    const {
      getAllStaffs,
      getAllEventCategories,
      getAllEvents,
      setOpenEditFolderModal,
      openEditFolderModal,
      handleSubmitCreateNewFolder,
      setAddNewProjectPopup,
      addNewProjectPopup,
      handleToggleEditFolder,
      setProjectID,
    } = useEditEventDetails();
    return (
      <>
        <div className={Style.AddStaffList__wrap}>
          <Table className={Style.AddStaffList}>
            {status !== "succeed" ? (
              <>
                <TableHeader
                  isActiveDropdown={isActiveDropdown}
                  setIsActiveDropdown={setIsActiveDropdown}
                  handleStaffFilter={handleStaffFilter}
                />
                <tbody>
                  <tr>
                    <td
                      colSpan={6}
                      align="center"
                      className="py-5 border-bottom-0"
                    >
                      {[...Array(5)]?.map((_, i) => (
                        <ShimmerThumbnail
                          height={windowDimensions?.width > 991 ? 30 : 200}
                          rounded
                          className={Style.shimmerBars}
                        />
                      ))}
                    </td>
                  </tr>
                </tbody>
              </>
            ) : staffViewData?.data?.length == 0 ? (
              <>
                <TableHeader
                  isActiveDropdown={isActiveDropdown}
                  setIsActiveDropdown={setIsActiveDropdown}
                  handleStaffFilter={handleStaffFilter}
                />
                <tbody>
                  <tr>
                    <td
                      colSpan={6}
                      align="center"
                      className="py-5 border-bottom-0"
                    >
                      <div className="py-5">
                        <figure className="mb-0 ratio">
                          <img src={Assets.add_staff} alt="" />
                        </figure>
                        <h3 className={Style.no_staff__title}>
                          No staff added
                        </h3>
                      </div>
                    </td>
                  </tr>
                </tbody>
              </>
            ) : (
              <>
                <TableHeader
                  isActiveDropdown={isActiveDropdown}
                  setIsActiveDropdown={setIsActiveDropdown}
                  handleStaffFilter={handleStaffFilter}
                />

                <tbody className={Style.AddStaffList__contents}>
                  {staffViewData?.data?.map((staff, index) => {
                    const lastIndex = staffViewData?.data?.length - 1;

                    return (
                      <React.Fragment key={index}>
                        <AddStaffCard
                          designations={designations}
                          staffData={staff}
                          name={staff?.name}
                          phone={staff?.mobile}
                          email={staff?.email}
                          ref={ref}
                          staff_assigned={staff.staff_assigned}
                          lastIndex={lastIndex}
                          itemIndex={index}
                          staffID={staff.id}
                          handletoggleStaffEdit={handletoggleStaffEdit}
                          handleSetStaffEditData={handleSetStaffEditData}
                          handletoggleAssignedProjects={
                            handletoggleAssignedProjects
                          }
                          handlesetAssignedProjects={handlesetAssignedProjects}
                        />
                      </React.Fragment>
                    );
                  })}
                </tbody>
              </>
            )}
          </Table>
        </div>

        <AssignedProjectDetails
          isAssignedEventInfo={assignedProjects.status}
          setIsAssignedEventInfo={handletoggleAssignedProjects}
          setIsAddNewFolderModal={() => {}}
          handleToggleEditFolder={handleToggleEditFolder}
          setAddNewProjectPopup={setAddNewProjectPopup}
          setProjectID={setProjectID}
        />

        <AddNewFolderModal
          handleSubmitCreateNewFolder={handleSubmitCreateNewFolder}
          addNewProjectPopup={openEditFolderModal}
          setAddNewProjectPopup={setOpenEditFolderModal}
          isEventEdit={true}
        />
      </>
    );
  }
);

export default ContractStaff;
